import React from 'react';
import './Services.css';

function Services() {
  const categories = [
    {
      title: 'Color Services',
      services: [
        { name: 'Root Retouch', price: '$70+', duration: '90 min', desc: 'Perfect for covering any unwanted greys!' },
        { name: 'Root Retouch And Refresh', price: '$90+', duration: '120 min', desc: 'Covers roots and adds shine' },
        { name: 'Foils', price: '$150+', duration: '150 min', desc: 'Beautiful highlights for an overall lightened look' },
        { name: 'Mini Foil', price: '$105', duration: '60 min', desc: 'Small section of foils for subtle dimension' },
        { name: 'Partial Foil', price: '$100', duration: '90 min', desc: '12 foils or less for subtle dimension' },
        { name: 'Dimensional Color', price: '$175+', duration: '150 min', desc: 'Base color plus highlights' },
        { name: 'Accent Foil', price: '$35+', duration: '15 min', desc: 'Add-on for small dimension' },
        { name: 'Bleach and Tone Retouch', price: '$100+', duration: '150 min', desc: 'Bleach retouch under 1" growth' },
        { name: 'Bleach and Tone Virgin Application', price: '$250+', duration: '180 min', desc: 'Full lightening for virgin hair' },
        { name: 'Balayage', price: '$160+', duration: '150 min', desc: 'Hand-painted highlighting technique' },
        { name: 'Partial Balayage', price: '$110+', duration: '120 min', desc: 'Brightening for select areas' },
        { name: 'Ombre', price: '$150+', duration: '150 min', desc: 'Beautifully blended color gradient' },
        { name: 'Glossing', price: '$65', duration: '45 min', desc: 'Add shine or change tone' },
      ],
    },
    {
      title: 'Haircut Services',
      services: [
        { name: 'Haircut And Style', price: '$50', duration: '45 min', desc: '' },
        { name: 'Xpress Haircut', price: '$38', duration: '30 min', desc: 'Cut without blowdry' },
        { name: 'Short Haircut', price: '$25', duration: '30 min', desc: 'Hair 4" or shorter' },
        { name: 'Add On Haircut', price: '$20', duration: '30 min', desc: 'Paired with chemical services' },
        { name: 'Clipper Cut', price: '$25', duration: '30 min', desc: 'Buzzed with clippers' },
        { name: 'Kids Haircut', price: '$18', duration: '20 min', desc: '' },
        { name: 'Bang Trim', price: '$15', duration: '10 min', desc: '' },
      ],
    },
    {
      title: 'Styling Services',
      services: [
        { name: 'Blowdry Style', price: '$45+', duration: '45 min', desc: '' },
        { name: 'Iron Works', price: '$15', duration: '30 min', desc: 'Flat iron or curling iron' },
        { name: 'Formal Styling', price: '$70', duration: '45 min', desc: 'Special occasion styling' },
      ],
    },
    {
      title: 'Treatment Services',
      services: [
        { name: 'Olaplex Moisture Treatment', price: '$25', duration: '30 min', desc: '' },
        { name: 'Olaplex Treatment Stand Alone', price: '$45', duration: '30 min', desc: '' },
        { name: 'Olaplex With Color Service', price: '$25', duration: '10 min', desc: 'Add-on during color' },
      ],
    },
  ];

  return (
    <main className="services-page">
      {/* Page Header */}
      <section className="services-header">
        <div className="services-header__content">
          <h1 className="services-header__title">Our Services</h1>
          <p className="services-header__subtitle">Expert hair care tailored to you</p>
        </div>
      </section>

      {/* Services Listing */}
      <section className="section" style={{ backgroundColor: '#faf8f6' }}>
        <div className="container">
          <p className="services-page__note">
            Prices may vary based on hair length and condition. All services include a consultation.
          </p>

          {categories.map((category, catIndex) => (
            <div className="services-category" key={catIndex}>
              <h2 className="services-category__title">{category.title}</h2>
              <div className="services-category__list">
                {category.services.map((service, srvIndex) => (
                  <div className="service-row" key={srvIndex}>
                    <div className="service-row__info">
                      <h3 className="service-row__name">{service.name}</h3>
                      {service.desc && (
                        <p className="service-row__desc">{service.desc}</p>
                      )}
                    </div>
                    <div className="service-row__meta">
                      <span className="service-row__duration">{service.duration}</span>
                      <span className="service-row__price">{service.price}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <div className="services-page__cta">
            <h3 className="services-page__cta-title">Ready to book?</h3>
            <p className="services-page__cta-text">
              Schedule your appointment online and let us take care of the rest.
            </p>
            <a
              href="https://epichairsalon.glossgenius.com/services"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Book Now
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Services;
